module.exports = __webpack_public_path__ + "img/ico037.0eccfe3d.svg";